module.exports = __webpack_public_path__ + "img/littl_girls7.f9af1d26.jpg";